import React, { useEffect, useRef } from "react";
import CompanyBlock from "./CompanyBlock";

// Renders every company's project feed and watches scroll position so the
// sidebar dot / mobile tab for the company currently in view stays active.
function HomeView({
  companies,
  expanded,
  onToggleExpand,
  onOpenCaseStudy,
  onActiveCompanyChange,
}) {
  const blockRefs = useRef([]);

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = blockRefs.current.indexOf(entry.target);
            if (idx !== -1) onActiveCompanyChange(idx);
          }
        });
      },
      { threshold: 0.3 }
    );
    blockRefs.current.forEach((el) => {
      if (el) io.observe(el);
    });
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies]);

  return (
    <div className="home-main">
      <div className="home-header">
        <h1 className="showcase">showcase</h1>
      </div>
      <div className="home-main-inner" id="home-main">
        {companies.map((co, ci) => (
          <div
            key={co.id}
            id={co.id}
            className="co-block"
            ref={(el) => (blockRefs.current[ci] = el)}
          >
            <CompanyBlock
              company={co}
              companyIndex={ci}
              isOpen={!!expanded[ci]}
              onToggleExpand={() => onToggleExpand(ci)}
              onOpenCaseStudy={onOpenCaseStudy}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomeView;
